export default class JSONUtil {

    static replaceBasePath(jsonData, prefix=null) {
        if(jsonData?.common?.asset_base_path) {
            let basePath = jsonData.common.asset_base_path;

            if (prefix) {
                basePath = prefix + basePath;
                // remove duplicate slashes
                basePath = basePath.replace(/\/+/g, '/');
            }
            let stringified = JSON.stringify(jsonData);
            stringified = stringified.replace(/\$\$asset_base_path\$\$/g, basePath);
            return JSON.parse(stringified);
        }
        else {
            return jsonData;
        }
    }

    static searchReplace(jsonData, searchStr, replaceStr) {
        return JSON.parse(JSON.stringify(jsonData).replace(new RegExp(searchStr, 'g'), replaceStr));
    }
}
